import React from "react";
import { useAccount } from 'wagmi';
import { trimAddress } from "../helper/constant";
import { useAppKit } from "@reown/appkit/react";

export default function Connect(){
   const { open } = useAppKit();
  const { address, isConnected } = useAccount();
  return (

    <button type="button" onClick={() => open()} className="cs-btn">
      {isConnected && address ? trimAddress(address) : "Connect Wallet"}
    </button>
  );
};